/**
 * @since 7.1.0
 */
export var EventSpan;
(function (EventSpan) {
    /**
     * @since 7.1.0
     */
    EventSpan[EventSpan["THIS_EVENT"] = 0] = "THIS_EVENT";
    /**
     * @since 7.1.0
     */
    EventSpan[EventSpan["THIS_AND_FUTURE_EVENTS"] = 1] = "THIS_AND_FUTURE_EVENTS";
})(EventSpan || (EventSpan = {}));
//# sourceMappingURL=event-span.js.map